<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="approvallevelForm">
      <div class="">
        <h3 class="form_name">Approval Level</h3>
  
        <div class="input">
          <label for="">Level</label>
          <input type="text" class="default_input reference-form" (keyup)="checkForExistingLevel(approvallevelForm.value)"   formControlName="LevelName" />
        </div>
        <div class="input">
            <label for="">Level Priority</label>
            <input type="number" class="default_input reference-form" formControlName="LevelPriority" (keyup)="checkForExistingPriority(approvallevelForm.value)" />
          </div>
    
      
        
  
        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null" 
            (click)="addNew(approvallevelForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null" 
            (click)="addNew(approvallevelForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
        </div>
  
      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Lorp name"
          />
          <em class="ti-search"></em> 
<!--   
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(approvallevels | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectedLorp(option.id)"
                  *ngFor="let option of result"
                  [value]="option.LorpName" 
                >
               
  
                  {{option.LorpName}}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete> -->
        </div>
  
        <div class="head" >
          <span class="item">S/N</span>
         
          <span class="item">Level Name</span>

          <span class="item">Level Priority</span>

        
          <span class="item">Action</span>
  
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let approvallevel of approvallevelFormArray.get('ApprovalLevels')['controls']; index as i"
        (click)="onEdit(i, approvallevel.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          
          <span class="content">{{approvallevel.value.LevelName}}</span>
          <span class="content">{{approvallevel.value.LevelPriority}}</span>

         
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteApprovalLevel(i, approvallevel.value)">
            <em class="ti-trash"> </em> </button>
          </span>
  
        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(approvallevelFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>